import React from "react";
import { Flex, Tooltip, Dropdown, Menu, Card, Typography } from "antd";

const { Text } = Typography;

const UserTooltip = ({ user, children }) => (
  <Tooltip
    title={
      <Card
        style={{
          width: 220,
          borderRadius: "8px",
          padding: "5px 10px",
          backgroundColor: "white",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Flex
          justify="space-between"
          align="center"
          style={{ width: "100%", height: "0px" }}
        >
          <Text strong style={{ fontSize: "13px", color: "#000" }}>
            {user?.user}
          </Text>

          <div
            style={{
              width: 35,
              height: 35,
              backgroundColor: "#1677FF",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            {user.user
              .split(" ")
              .map((n) => n[0])
              .join("")
              .toUpperCase()}
          </div>
        </Flex>
      </Card>
    }
    overlayInnerStyle={{
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "0px",
    }}
    arrow={{
      pointAtCenter: true,
      className: "custom-tooltip-arrow",
    }}
    overlayStyle={{
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    }}
  >
    {children}
  </Tooltip>
);

const CircleGroup = ({ viewers = [] }) => {
  const visibleUsers = viewers.slice(0, 2); 
  const extraUsers = viewers.slice(2);

  return (
    <Flex style={{ position: "relative", gap: "-10px" }}>
      {visibleUsers.map((user, index) => (
        <UserTooltip key={user.id} user={user}>
          <div
            style={{
              width: 40,
              height: 40,
              backgroundColor: "#1677FF",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "14px",
              marginLeft: index === 0 ? 0 : "-10px",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
              border: "2px solid white",
              cursor: "pointer",
            }}
          >
            {user.user
              .split(" ")
              .map((n) => n[0])
              .join("") 
              .toUpperCase()}
          </div>
        </UserTooltip>
      ))}

      {extraUsers.length > 0 && (
        <Dropdown
          overlay={
            <Menu
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              {extraUsers.map((user) => (
                <Menu.Item key={user.id} style={{ padding: "10px" }}>
                  <Flex justify="space-between" align="center">
                    <div>
                      <Text strong style={{ fontSize: "14px" }}>
                        {user.user}
                      </Text>
                    </div>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        backgroundColor: "#1677FF",
                        borderRadius: "50%",
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                    >
                      {user.user
                        .split(" ")
                        .map((n) => n[0])
                        .join("") 
                        .toUpperCase()}
                    </div>
                  </Flex>
                </Menu.Item>
              ))}
            </Menu>
          }
          trigger={["click"]}
        >
          <div
            style={{
              width: 40,
              height: 40,
              backgroundColor: "#444",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "14px",
              marginLeft: "-10px",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
              border: "2px solid white",
              cursor: "pointer",
            }}
          >
            +{extraUsers.length}
          </div>
        </Dropdown>
      )}
    </Flex>
  );
};

export default CircleGroup;
